import {
  DirectiveFormLayout,
  DirectiveFormProps,
} from 'components/directive/directiveFormLayout/DirectiveFormLayout'
import { TDirectiveStep } from 'components/directive/directiveStepsNav/DirectiveStepsNav'
import { getDirectiveSpec } from 'components/directive/utils/directiveSpecs'
import { DirectiveType } from 'components/directive/utils/types'
import { EitherUserDirectiveSwr } from 'logic/directive/types'
import { useTranslation } from 'next-i18next'
import { toLowerCase } from 'utils/general'

export function SimpleDirectiveLayout(
  props: Omit<
    DirectiveFormProps,
    'steps' | 'isLoading' | 'onNext' | 'directiveSpec' | 'dataTestIdPrefix'
  > & {
    directiveSwr?: EitherUserDirectiveSwr
    directiveType: DirectiveType
  }
) {
  const { directiveSwr, directiveType, ...passProps } = props

  const dataLoading = directiveSwr && !directiveSwr?.data

  const steps = useSimpleDirectiveSteps(directiveType)

  return (
    <DirectiveFormLayout
      {...passProps}
      dataTestIdPrefix={toLowerCase(directiveType)}
      steps={steps}
      isLoading={dataLoading}
      directiveSpec={getDirectiveSpec(directiveType)}
      noExit
      simple
    />
  )
}

const simpleWillSteps = [
  'basics',
  'checkout',
  'your_property',
  'executors_and_witnesses',
  'print_sign',
] as const

const simpleTrustSteps = [
  'basics',
  'checkout',
  'trustees',
  'property',
  'will',
  'print_sign',
] as const

export function useSimpleDirectiveSteps(directiveType: DirectiveType) {
  const { t } = useTranslation('directive')
  const stepKeys =
    directiveType === 'WILL' ? simpleWillSteps : directiveType === 'TRUST' ? simpleTrustSteps : []

  return stepKeys.map((key, i): TDirectiveStep => {
    const isFirst = i === 0
    const isDone = isFirst
    const isCurrent = isFirst
    const name = t(`directive.simple_steps.${key}`)
    return {
      disabled: true,
      url: '',
      value: key,
      hasError: null,
      isCurrent,
      isDone,
      name,
      mobileName: name,
    }
  })
}
